/**
 * @workspace/voice-chat-ui
 * JSX components and hooks for voice chat - works with React and Preact
 */

// Components
export {
  Iridescence,
  TalkingOrb,
  LoadingDots,
  VoiceVisualizer,
  ConversationStatusIndicator,
  DeviceSelector,
  LiveControls,
  // Icons
  MicIcon,
  MicOffIcon,
  PauseIcon,
  PlayIcon,
  ChevronDownIcon,
  AlertTriangleIcon,
  WifiOffIcon,
  Volume2Icon,
  CheckIcon,
} from "./components";

// Hooks
export {
  useAudioLevel,
  useMicrophonePermission,
  useMediaDevices,
  useConversation,
  useVoiceChatSession, // Legacy alias
} from "./hooks";

// Types
export type {
  ConversationStatus,
  ConnectionState,
  NetworkQualityState,
} from "./components";
export type {
  MicrophonePermissionState,
  MediaDeviceInfo,
  UseConversationOptions,
  UseVoiceChatSessionOptions, // Legacy alias
} from "./hooks";
export type {
  BootConfig,
  ConnectionInfo,
  ConversationInfo,
  SessionStartResponse,
  SessionState,
  SheetState,
} from "./types";

// Lib utilities (for advanced usage)
export {
  createAudioLevelAnalyzer,
  type AudioLevelAnalyzer,
} from "./lib/audio-level";
export {
  createMicrophonePermissionManager,
  type MicrophonePermissionManager,
} from "./lib/microphone-permission";
export {
  createMediaDeviceManager,
  type MediaDeviceManager,
  type MediaDeviceState,
  type MediaDeviceManagerOptions,
} from "./lib/media-devices";
export {
  VoiceChatApiClient,
  createVoiceChatApiClient,
  captureBrowserContext,
  type VoiceChatApiClientOptions,
  type CreateConversationOptions,
  type TokenRefreshCallback,
  type TokenRefreshContext,
} from "./lib/api-client";

// Design tokens
export {
  tokens,
  colors,
  spacing,
  fontSize,
  fontWeight,
  fontFamily,
  radius,
  shadows,
  duration,
  easing,
  zIndex,
  button,
  card,
  dropdown,
  colorWithOpacity,
} from "./tokens/design-tokens";

// Strings (for i18n and external consumers)
export { strings, getString } from "./strings";
export type { Strings, StringKey } from "./strings";
